module.exports = __webpack_public_path__ + "static/replace-tall-bd69714407a70fc3c8ec921f65619ae3.jpg";